module.exports = __webpack_public_path__ + "static/img/t38.cd40ee1b.png";